import axiosInstance from './axiosInstance'

export interface Conversation {
  id: number
  clientId: number
  coachId: number
  canSend: boolean
  // Every message of mine with id <= this has been seen by the other side.
  otherLastReadMessageId: number
}

export interface ConversationSummary {
  id: number
  myRole: 'CLIENT' | 'COACH'
  clientId: number
  coachId: number
  otherMemberId: number
  otherName: string
  otherPhotoUrl: string | null
  lastMessageId: number
  lastMessageBody: string
  lastMessageSenderId: number
  lastMessageAt: string | null
  unreadCount: number
  canSend: boolean
}

export interface Message {
  id: number
  conversationId: number
  senderId: number
  body: string
  clientMessageId: string
  createdAt: string
}

export interface MessagePage {
  conversation: Conversation
  messages: Message[]
}

export const MAX_MESSAGE_CHARS = 4000

export async function openConversationWithClient(clientId: number): Promise<Conversation> {
  const res = await axiosInstance.post<Conversation>(`/api/v1/conversations/with-client/${clientId}`)
  return res.data
}

export async function listConversations(): Promise<ConversationSummary[]> {
  const res = await axiosInstance.get<ConversationSummary[]>('/api/v1/conversations')
  return res.data
}

export async function getUnreadCount(): Promise<number> {
  const res = await axiosInstance.get<{ count: number }>('/api/v1/conversations/unread-count')
  return res.data.count
}

// Without afterId: history older than beforeId (or the latest), newest first.
// With afterId: what arrived after it, oldest first.
export async function getMessages(
  conversationId: number,
  params: { beforeId?: number; afterId?: number; limit?: number } = {},
): Promise<MessagePage> {
  const res = await axiosInstance.get<MessagePage>(`/api/v1/conversations/${conversationId}/messages`, { params })
  return res.data
}

export async function sendMessage(conversationId: number, body: string, clientMessageId: string): Promise<Message> {
  const res = await axiosInstance.post<Message>(`/api/v1/conversations/${conversationId}/messages`, {
    body,
    clientMessageId,
  })
  return res.data
}

export async function markConversationRead(conversationId: number, messageId: number): Promise<void> {
  await axiosInstance.post(`/api/v1/conversations/${conversationId}/read`, { messageId })
}
